import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParentApiService } from './parent-api-service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { PackagingUnitInfoDto } from '../entities/packaging-unit-entities/packaging-unit-info-dto';
import { PaginationQueryDto } from '../entities/pagination-query-dto';
import { PaginationResponseDto } from '../entities/pagination-response-dto';
import { PackagingSystemInfoDto } from '../entities/packaging-system-entities/packaging-system-info-dto';
import { ProblemInformationDto } from '../entities/evaluation-entities/problem-information-dto';
import { GS1TransferResultDto } from '../entities/gs1-transfer-result-dto';

@Injectable({ providedIn: 'root' })
export class Gs1DataTransferApiService extends ParentApiService {

  constructor(private http: HttpClient) { super(); }

  public getTransferredPackagingUnits(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PackagingUnitInfoDto>> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-units/transferred`;

    return this.http.post<PaginationResponseDto<PackagingUnitInfoDto>>(url, paginationQuery);
  }

  public getPackagingUnitsReadyForTransfer(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PackagingUnitInfoDto>> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-units/ready-for-transfer`;

    return this.http.post<PaginationResponseDto<PackagingUnitInfoDto>>(url, paginationQuery);
  }

  public getPackagingUnitsRequiringReview(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PackagingUnitInfoDto>> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-units/review-required`;

    return this.http.post<PaginationResponseDto<PackagingUnitInfoDto>>(url, paginationQuery);
  }

  public transferPackagingUnits(packagingUnitIds: number[]): Observable<GS1TransferResultDto> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-units/transfer`;

    return this.http.post<GS1TransferResultDto>(url, packagingUnitIds);
  }

  public getPackagingUnitProblemInformation(packagingUnitId: number): Observable<ProblemInformationDto[]> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-units/problem-information?packagingUnitId=${packagingUnitId}`;

    return this.http.get<ProblemInformationDto[]>(url);
  }

  public getTransferredPackagingSystems(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PackagingSystemInfoDto>> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-systems/transferred`;

    return this.http.post<PaginationResponseDto<PackagingSystemInfoDto>>(url, paginationQuery);
  }

  public getPackagingSystemsReadyForTransfer(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PackagingSystemInfoDto>> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-systems/ready-for-transfer`;

    return this.http.post<PaginationResponseDto<PackagingSystemInfoDto>>(url, paginationQuery);
  }

  public getPackagingSystemsRequiringReview(paginationQuery: PaginationQueryDto): Observable<PaginationResponseDto<PackagingUnitInfoDto>> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-systems/review-required`;

    return this.http.post<PaginationResponseDto<PackagingSystemInfoDto>>(url, paginationQuery);
  }

  public transferPackagingSystems(packagingSystemIds: number[]): Observable<GS1TransferResultDto> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-systems/transfer`;

    return this.http.post<GS1TransferResultDto>(url, packagingSystemIds);
  }

  public getPackagingSystemProblemInformation(packagingSystemId: number): Observable<ProblemInformationDto[]> {
    const url = `${environment.webApiAddress}/api/gs1/data-transfer/packaging-systems/problem-information?packagingSystemId=${packagingSystemId}`;

    return this.http.get<ProblemInformationDto[]>(url);
  }
}
